module.exports = __webpack_public_path__ + "b4e5f5c49d86adbfc73a0fe5a1bef6aa.png";